module.exports = __webpack_public_path__ + "files/eef59d79789421e82c6b58b0acb54e27.png";